import styled, { css } from 'styled-components';
import { MenuButton, MenuItem, Box } from '@bechtel/gds';

interface MenuButtonProps {
  isDisabled: boolean;
}
export const MenuButtonStyled = styled(MenuButton)<MenuButtonProps>`
  ${({ theme }) => css`
    padding: ${theme.spacings[400]};
    display: inline-flex;
    border-color: none;
    pointer-events: all;
    height: ${theme.spacings['700']};
    opacity: 1;
    align-items: center;
    box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px, rgb(0 0 0 / 12%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px;
    &:focus {
      box-shadow: none;
    }
  `}
  ${(props: MenuButtonProps) =>
    props.isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.6;
    `}
`;
interface MenuItemStyledProps {
  isActive: boolean;
  isDisabled: boolean;
}
export const MenuItemStyled = styled(MenuItem)<MenuItemStyledProps>`
  ${({ theme }) => css`
    width: 228px;
    max-height: ${theme.spacings[800]};
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: ${theme.fontSizes[400]};
    padding-left: ${theme.spacings[500]};
    color: ${theme.colors.grey[1000]};
    white-space: nowrap;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.grey[300]};
    }
    ${(props: MenuItemStyledProps) =>
      props.isActive &&
      css`
        background-color: ${theme.colors.bechtel.blue[100]};
        &:hover {
          background-color: ${theme.colors.bechtel.blue[100]};
        }
      `}
    ${(props: MenuItemStyledProps) =>
      props.isDisabled &&
      css`
        pointer-events: none;
        opacity: 0.6;
      `}
  `}
`;

export const PopperContainerStyled = styled(Box)`
  ${({ theme }) => css`
    border-radius: ${theme.spacings[200]};
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: ${theme.spacings[700]};
  `}
`;

export const FilterIconStyled = styled.img`
  ${({ theme }) => css`
    width: calc(${theme.spacings[600]} + ${theme.spacings[200]});
    height: calc(${theme.spacings[600]} + ${theme.spacings[200]});
  `}
`;
